export function generateReferralCode(uid: string): string {
    let hash = 0;
    for (let i = 0; i < uid.length; i++) {
        hash = (hash << 5) - hash + uid.charCodeAt(i);
        hash |= 0;
    }
    let code = Math.abs(hash).toString(36).slice(0, 8);
    code = code
        .split('')
        .map(char => (/[a-z]/.test(char) && Math.random() > 0.5 ? char.toUpperCase() : char))
        .join('');
    return code;
}

export function createAvatarUrl(name: string) {
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random&color=fff&size=256`;
}